import { apiPrefix } from '../constants'

export default {
  getDefaultLabelLevels: {
    type: 'get',
    url: `${apiPrefix}defaultlabellevel`,
  },
  deleteDefaultLabelLevels: {
    type: 'delete',
    url: `${apiPrefix}defaultlabellevel`,
  },
  addDefaultLabelLevels: {
    type: 'post',
    url: `${apiPrefix}defaultlabellevel`,
  },
  updateDefaultLabelLevels: {
    type: 'put',
    url: `${apiPrefix}defaultlabellevel`,
  },
}
